import { useEffect, useState } from "react";
import { MotionConfig, motion } from "framer-motion";
import PropTypes from "prop-types";

export const AnimatedHamburgerButton = ({ active, onClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <MotionConfig
      transition={{
        duration: 0.5,
        ease: "easeInOut",
      }}
    >
      <motion.button
        initial={false}
        animate={active ? "open" : "closed"}
        onClick={onClick}
        className={`relative w-10 h-10 transition-colors rounded-full ${
          isScrolled
            ? "bg-black/0 hover:bg-black/20"
            : "bg-white/0 hover:bg-white/20"
        }`}
      >
        <motion.span
          variants={VARIANTS.top}
          className="absolute h-0.5 w-6"
          style={{
            backgroundColor: isScrolled ? "black" : "white",
            y: "-50%",
            left: "50%",
            x: "-50%",
            top: "35%",
          }}
        />
        <motion.span
          variants={VARIANTS.middle}
          className="absolute h-0.5 w-6"
          style={{
            backgroundColor: isScrolled ? "black" : "white",
            left: "50%",
            x: "-50%",
            top: "50%",
            y: "-50%",
          }}
        />
        <motion.span
          variants={VARIANTS.bottom}
          className="absolute h-0.5 w-4"
          style={{
            backgroundColor: isScrolled ? "black" : "white",
            x: "-50%",
            y: "50%",
            bottom: "35%",
            left: "calc(50% + 4px)",
          }}
        />
      </motion.button>
    </MotionConfig>
  );
};

AnimatedHamburgerButton.propTypes = {
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const VARIANTS = {
  top: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      top: ["35%", "50%", "50%"],
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      top: ["50%", "50%", "35%"],
    },
  },
  middle: {
    open: {
      rotate: ["0deg", "0deg", "-45deg"],
    },
    closed: {
      rotate: ["-45deg", "0deg", "0deg"],
    },
  },
  bottom: {
    open: {
      rotate: ["0deg", "0deg", "45deg"],
      bottom: ["35%", "50%", "50%"],
      left: "50%",
    },
    closed: {
      rotate: ["45deg", "0deg", "0deg"],
      bottom: ["50%", "50%", "35%"],
      left: "calc(50% + 4px)",
    },
  },
};
